module.exports = __webpack_public_path__ + "static-v-shop/1765543028354/img/57243.c258695d.jpg";